import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export function isFallecido(cedula) {
  return API.get(Constants.APIURLS.ISFALLECIDO + cedula);
}

export function isAffiliate(cedula) {
  return API.get(Constants.APIURLS.ISAFILIADO + cedula );
}